module.exports = __webpack_public_path__ + "images/referenzen/produktfilm/panasonic_espresso_machine_za1.jpg";